

<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <!-- <div class="modal-header">
        <h4 class="modal-title">{{ data.title || 'Notification' }} </h4>  
           <div class="modal_close_btn"  (click)="close()">
            <span class="modal-close" ><i class="material-icons">close</i></span>
          </div> 
        </div> -->
        <div mat-dialog-content>
          <!-- Modal-Body -->
          <div class="modal-body">
            <!-- <div class="modal_close_btn">
              <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
            </div> -->
            <div class="status_details">
              <!-- <div class="status_img">
                <img src="../../../../../assets/images/icons/success.svg" alt="">
              </div> -->
              <div class="status_content">
                <h4 style="margin: 20px auto; width: 100%;">{{ data.message }} </h4>
                <!-- <p>You can Track Order on My Orders</p> -->

                <div fxLayout="column" fxLayoutAlign="center center" >

       <ng-container *ngIf="data.type === 'confirm'; else alertMode">
 
    <button mat-button class="modal-save-btn global-btn modal-footer-btn" (click)="close(true)" style="    margin: 10px auto 10px auto;">
      {{ data.confirmText || 'OK' }}
    </button>
  </ng-container>
    <ng-template #alertMode>
    <button mat-button class="modal-save-btn global-btn modal-footer-btn" (click)="close(true)" style="    margin: 10px auto 10px auto;">OK</button>
  </ng-template>
 </div>

              </div>
            </div>
          </div>
        </div>
      <!-- </perfect-scrollbar> -->

    </div>
  </div>
</div>





